import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Profile.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import User from "../Modules/User";
class Profile extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            payment_type:-1,
            discount_code:"",
            dialogHasConfirm:false,
            balance:0,
            countUnreadMessages:0,
            debt:0,
            name:""
        };
    }

    componentDidMount(){
        this.getUserData();
    };

    render() {
        let nextButton = (
            <button id={"posBtn"} onClick={()=>{this.pay(0)}}>
                <img src={`${process.env.PUBLIC_URL}/assets/images/pos.png`} className={"posImg"}/> درب منزل
            </button>
        );
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);

        let dialogConfirm = "";
        if(this.state.dialogHasConfirm)
            dialogConfirm = (
                <Button onClick={this.handleConfirm} color="success" autoFocus>
                    تایید
                </Button>
            );
        return (
            <div className="App ">
                <Loading loading={this.state.loading}/>
                <div className="App-body bg-white">
                    <div className={"content Profile"}>
                        <div id={"profilePrimary"}>
                           <img id={"profileImg"} src={`${process.env.PUBLIC_URL}/assets/images/account.png`}/>
                            <div style={{color:"white"}}>{this.state.name}</div>
                        </div>
                        <div id={"profileButtons"}>
                            <div className={"profileItem"} onClick={()=>{this.props.history.push("/messages")}}>
                                <div className={"profileInfoText"}>پیام ها</div>
                                <img className={"profileInfoImg"} src={`${process.env.PUBLIC_URL}/assets/images/message.png`}/>
                            </div>
                            <div className={"profileItem"} onClick={()=>{ls.set("report_type",2);this.props.history.push({pathname: '/reports', state: {type:2}})}}>
                                <div className={"profileInfoText"}>تاریخچه حساب</div>
                                <img className={"profileInfoImg"} src={`${process.env.PUBLIC_URL}/assets/images/orderlist.png`}/>
                            </div>
                            <div className={"profileItem"} onClick={()=>{this.props.history.push('address')}}>
                                <div className={"profileInfoText"}>آدرس ها</div>
                                <img className={"profileInfoImg"} src={`${process.env.PUBLIC_URL}/assets/images/address.png`}/>
                            </div>
                        </div>
                        <div id={"profileWalletRow"}>
                            <div id={"profileWalletLabel"}>موجودی کیف پول :</div>
                            <div id={"profileWalletValue"}>{(this.state.balance == 0)?"خالی":this.state.balance+" تومان"}</div>
                        </div>
                        <div id={"profileDebtRow"}>
                            <div id={"profileDebtLabel"}>میزان بدهی باشگاه مشتریان :</div>
                            <div id={"profileDebtValue"}>{(this.state.balance == 0)?"صفر":this.state.debt+" تومان"}</div>
                        </div>
                    </div>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {this.state.dialogText}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                بستن
                            </Button>
                            {dialogConfirm}
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        );
    }

    handleClose  = () => {
        this.setState({open:false})
    };

    getUserData(){
        axios.get(urls.baseUrl+urls.checkClient+"?token="+ls.get("token"))
            .then(res => {
                if(res.data.code == 200){
                    let user = new User();
                    user.setData(res.data.user);
                    user.balance = res.data.wallet.balance;
                    user.countUnreadMessages = res.data.countUnreadMessages;
                    ls.set("user",user);
                    this.setState({
                        balance:user.balance,
                        countUnreadMessages:user.countUnreadMessages,
                        debt:user.debit,
                        name:user.fnamelname
                    });
                }
                else{
                    ls.remove("user");
                    ls.remove("token");
                    ls.remove("phone");
                    this.props.history.push("/");
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,gotUser:false,badUser:true,loading:false});
            });
    }
}



export default Profile;
